module.exports = __webpack_public_path__ + "static/media/appicon2.56ab36f5.png";